const isProjectDetailView = (pathname) =>
  [/\/projects\/[0-9]+/, /\/templates\/[0-9]+/, /\/connectivity-advisor\/[0-9]+/].some((pattern) => pattern.test(pathname));

export default isProjectDetailView;
